import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom'; // 1. Import BrowserRouter
import "./disableLogsInProd";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 2. Wrap your App component */}
    <BrowserRouter>
    <App />
    </BrowserRouter>
  </React.StrictMode>
);
// No page service worker: remove any left by older builds and the copies of
// the site they stored (see src/service-worker.js). Push uses its own worker
// (firebase-messaging-sw.js), which is kept.
serviceWorkerRegistration.unregister();
if ('caches' in window) {
  caches.keys()
    .then((keys) => Promise.all(keys.filter((k) => /workbox|precache|runtime/i.test(k)).map((k) => caches.delete(k))))
    .catch(() => {});
}
